import { TableBody } from "@mui/material";
import styles from "./RevenueRow.module.scss";
import { Field, useField, useForm } from "react-final-form";
import { financialYearLabel } from "./RevenueDetails";
import OutlinedFormInput from "../../Finance/components/OutlinedFormInput/OutlinedFormInput";
import {
  onBlurFormatNumber,
  parseNumberForDB,
} from "../../../components/functions/utilities";
import { TableForm, TableFormBody } from "../components/TableForm/TableForm";
import TableUpload from "../components/TableForm/TableUploadCell";
import { useContext, useMemo, useState } from "react";
import { UnderwritingFormContext } from "../context/UnderwritingFormContext";
import {
  UnderwritingSteps,
  alignmentType,
} from "../../../interfaces/interfaces";
import { OnChange } from "react-final-form-listeners";
import { getIn } from "final-form";
import { useFieldArray } from "react-final-form-arrays";
import Switch from "react-switch";
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { Modal } from "reactstrap";
import ProvisionalStatement from "./ProvisionalStatement";
import MultiFileUploadModal from "../components/MultiFileUploadModal/MultiFileUploadModal";
import { MdOutlineFileUpload as UploadIcon } from "react-icons/md";
import { RiCheckboxCircleFill as SuccessIcon } from "react-icons/ri";

type Props = {
  fieldName: string;
  fieldIndex: number;
  newUploadedDocIds: number[];
  setNewUploadedDocIds: React.Dispatch<React.SetStateAction<number[]>>;
  deleteDocIds: number[];
  setDeleteDocIds: React.Dispatch<React.SetStateAction<number[]>>;
};

const RevenueRow = ({
  fieldName,
  fieldIndex,
  newUploadedDocIds,
  setNewUploadedDocIds,
  deleteDocIds,
  setDeleteDocIds,
}: Props) => {
  const { formCompleteStatus, changeUploadStatus } = useContext(
    UnderwritingFormContext
  );
  const [showUpload, setShowUpload] = useState(false);
  const { getState, mutators, getFieldState } = useForm();

  const [isOpenProvisional, setIsOpenProvisional] = useState(false);

  const {
    fields: { value: revenueArrValue },
  } = useFieldArray(`revenueDetails`);

  // const { field: { value: currentRevenue } } = useField(`${fieldName}.revenue`);

  const financialYearDetails = getIn(
    getState()?.values,
    `${fieldName}.financialYearDetails`
  );
  const isAuditedFinancials = getIn(
    getState()?.values,
    `${fieldName}.isAuditedFinancials`
  );
  const auditedFinancialsDoc = getIn(
    getState()?.values,
    `${fieldName}.auditedFinancials`
  );
  // console.log('financialYearDetails', fieldName, financialYearDetails)

  const [isMultiFileUploadOpen, setIsMultiFileUploadOpen] = useState(false);

  const showRevenue = () => {
    const revenueCurrentArr = revenueArrValue[fieldIndex];
    if (!revenueCurrentArr?.revenue && revenueCurrentArr?.revenue !== 0) {
      console.log("coming inside");
      if (
        revenueCurrentArr?.auditedFinancials?.uploadedFile ||
        revenueCurrentArr?.itReturns?.uploadedFile
      ) {
        mutators.setFieldData(`${fieldName}.revenue`, {
          error: `Enter Revenue`,
        });
        return `Enter Revenue`;
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  const showUploadIcon = useMemo(() => {
    const revenueCurrentArr =
      getState()?.values?.revenueDetails[fieldIndex]?.revenue;
    // console.log('revenueCurrentArr')
    if (revenueCurrentArr || revenueCurrentArr == "0") {
      return true;
    } else {
      return false;
    }
  }, [getState()?.values?.revenueDetails[fieldIndex]?.revenue]);

  const isFyPassed = financialYearDetails?.fyPassed;
  return (
    <>
      <TableFormBody
        alignment={alignmentType.leftAlign}
        styles={!isFyPassed ? { backgroundColor: "#f9f9f9" } : {}}
      >
        <Field name={`${fieldName}.financialYear`}>
          {(props) => (
            <div className={styles.revenueYear}>
              <div>{financialYearLabel(props.input.value)}</div>
              <div>{!isFyPassed ? <>(YTD)</> : null}</div>
            </div>
          )}
        </Field>
      </TableFormBody>
      <TableFormBody
        alignment={alignmentType.leftAlign}
        styles={!isFyPassed ? { backgroundColor: "#f9f9f9" } : {}}
      >
        <Field
          validate={(values) => {
            const revenueCurrentArr = revenueArrValue[fieldIndex];
            if (!values && values !== 0) {
              if (revenueCurrentArr?.auditedFinancials?.length) {
                return `Enter Revenue`;
              }
            }
          }}
          name={`${fieldName}.revenue`}
        >
          {(props) => {
            // console.log('props error', `${fieldName}.revenue`, props.meta.error)
            return (
              <OutlinedFormInput
                {...props.input}
                textFieldType="filled"
                fieldType="lg"
                showBorder={false}
                placeholder={"10,00,000"}
                showPlaceholder={false}
                inpuType="number"
                containerStyles={{ padding: "0" }}
                name={props.input.name}
                value={props.input.value}
                onChange={(e) => {
                  // console.log('value', e.target.value)
                  const numericValue = parseNumberForDB(e.target.value, false);
                  // console.log('numeric value', numericValue)
                  props.input.onChange(numericValue);
                }}
                onBlur={(e) => {
                  // console.log('onBlur triggering')
                  // if (currentMonthValue?.inEffectValue == MetricValueType.updatedCost && currentMonthValue?.updatedCost && currentMonthValue?.apiCost) {
                  const value = props.input.value;
                  // console.log('value', value);
                  // console.log('value', value);
                  const formattedValue = onBlurFormatNumber(value, 0);
                  // console.log('formattedValue', formattedValue);
                  props.input.onChange(formattedValue);
                  console.log("inputValue", value);
                  props.input.onBlur(e);
                }}
                unitPlaceHolder="₹"
                error={props.meta.error}
                touched={props.meta.touched}
                isCurrency={true}
                maxLength={10}
              />
            );
          }}
        </Field>
      </TableFormBody>
      {/* <TableFormBody alignment={alignmentType.centerAlign} styles={!isFyPassed ? { backgroundColor: "#f9f9f9" } : {}}>
                <Field name={`${fieldName}.isAuditedFinancials`}>
                    {props => {
                        return (
                            <div className={styles.switchContainer}>
                                <Switch
                                    draggable={false}
                                    checked={props.input.value}
                                    onChange={(checked, event) => {
                                        props.input.onChange(checked);
                                    }}
                                    disabled={financialYearDetails?.isAuditedFinancialRequired}
                                    onColor="#100828"
                                    offColor="#D5D5D5"
                                    handleDiameter={20}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    boxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
                                    activeBoxShadow="0px 0px 1px 1px rgba(0, 0, 0, 0.2)"
                                    height={24}
                                    width={43}
                                    className={styles.switch}
                                    id="material-switch"
                                />
                            </div>
                        )
                    }}
                </Field>
            </TableFormBody> */}
      <TableFormBody
        alignment={alignmentType.centerAlign}
        styles={!isFyPassed ? { backgroundColor: "#f9f9f9" } : {}}
      >
        {isAuditedFinancials ? (
          <div className={styles.uploadBtnContainer}>
            {auditedFinancialsDoc?.length ? (
              <div className={styles.fileUploadedContainer}>
                <div className={styles.iconContainer}>
                  <SuccessIcon />
                </div>
                <div className={styles.successText}>
                  {`${auditedFinancialsDoc?.length} ${
                    auditedFinancialsDoc?.length > 1 ? "files" : "file"
                  } uploaded`}
                </div>
              </div>
            ) : null}
            <div className={styles.uploadIconContainer}>
              <MeritoButton
                type="tertiary"
                icon={<UploadIcon />}
                onlyIcon={true}
                onClick={() => {
                  setIsMultiFileUploadOpen(true);
                }}
              />

              {!isFyPassed && (
                <div className={styles.fyYearProvisionalText}>
                  Provisional BS or MIS
                </div>
              )}
            </div>

            <Field name={`${fieldName}.auditedFinancials`}>
              {(props) => {
                return (
                  <>
                    {props?.meta?.error && props?.meta?.touched ? (
                      <div className={styles.errorContainer}>
                        {props?.meta?.error}
                      </div>
                    ) : null}
                  </>
                );
              }}
            </Field>
          </div>
        ) : (
          <div className={styles.uploadBtnContainer}>
            <div>
              <MeritoButton
                type="primary-1"
                btnText="Add Details"
                onClick={() => {
                  // open provisional statement modal
                  setIsOpenProvisional(true);
                }}
              />
            </div>
            <Field name={`${fieldName}.provisionalStatement`}>
              {(props) => {
                return (
                  <>
                    {props?.meta?.error && props?.meta?.touched ? (
                      <div className={styles.errorContainer}>
                        {props?.meta?.error}
                      </div>
                    ) : null}
                  </>
                );
              }}
            </Field>
          </div>
        )}
      </TableFormBody>
      <Modal
        isOpen={isOpenProvisional}
        toggle={() => {
          setIsOpenProvisional(!isOpenProvisional);
        }}
        size="lg"
        fullscreen={true}
        keyboard={false}
      >
        <ProvisionalStatement
          setIsOpen={setIsOpenProvisional}
          fieldName={fieldName}
          financialDetails={financialYearDetails}
          isOpen={isOpenProvisional}
        />
      </Modal>
      <MultiFileUploadModal
        fieldName={`${fieldName}.auditedFinancials`}
        isOpen={isMultiFileUploadOpen}
        setIsOpen={setIsMultiFileUploadOpen}
        title={
          <>
            {`Upload ${
              !isFyPassed ? "Provisional" : "Audited"
            } Financials (FY ${financialYearDetails?.financialYear})`}
          </>
        }
        subtitle={
          <>
            Ensure audited financials have COI (Computation of Total Income),
            Tax Audit Report (3CA, 3CD) and Director's Audit Report.
          </>
        }
        stepType={UnderwritingSteps.revenue}
        uploadSectionType={"financials"}
        newUploadedDocIds={newUploadedDocIds}
        setNewUploadedDocIds={setNewUploadedDocIds}
        deleteDocIds={deleteDocIds}
        setDeleteDocIds={setDeleteDocIds}
      />
    </>
  );
};

export default RevenueRow;
